import {request} from "../../Base/HTTP";

export async function getCashFlowData(data) {
    return await request('/api/cash-flow/data', data);
}

export async function recalculateCashFlowData(data) {
    return await request('/api/cash-flow/recalculate', data);
}
